import { SvgIcon } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { NavLink } from 'react-router-dom';

import styles from './Menu.module.scss';
import headerStyles from '../header/Header.module.scss';
import appStyles from '../app/App.module.scss';

import MainIcon from '../../icons/menu.svg';
import Settings from '../../icons/settings.svg';
import Gear from '../../icons/gear.svg';
import List from '../../icons/list.svg';
import CheckedList from '../../icons/checked-list.svg';
import Stop from '../../icons/stop.svg';
import Network from '../../icons/network.svg';
import ChartRaises from '../../icons/chart-raises.svg';
import Help from '../../icons/help.svg';
import Account from '../../icons/account.svg';

import { BASE_URL } from '../../services/ADapi';

import {
  useGetMenuQuery,
  useGetAuthenticationQuery,
} from '../../services/ADapi';

const menuIcons = {
  menu__main_page: MainIcon,
  menu__main_user_administration: Settings,
  menu__main_settings: Gear,
  menu__main_agent_ad: Network,
  menu__main_categories: List,
  menu__main_allowlist: CheckedList,
  menu__main_denylist: Stop,
  menu__main_statistics: ChartRaises,
  menu__main_new_statistics: ChartRaises,
  menu__main_support: Help,
  menu__main_account: Account,
};

// TODO: optimize custom icons imports
const CollapseIcon = () => (
  <SvgIcon>
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16699 13.4456L9.29322 8.31941C9.68374 7.92889 10.3169 7.92889 10.7074 8.31941L15.8337 13.4456"
        stroke="#141C24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

const ExpandIcon = () => (
  <SvgIcon>
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 7.69531L9.70711 12.2382C9.31658 12.6287 8.68342 12.6287 8.29289 12.2382L3.75 7.69531"
        stroke="#141C24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

const Link = ({ url, title, icon }) => (
  <NavLink to={url} className={styles['menu-item']}>
    {icon ? <img src={icon} alt="menu icon" /> : null}
    {title}
  </NavLink>
);

const Menu = () => {
  const {
    data: { username, is_authenticated },
  } = useGetAuthenticationQuery();

  const { data: menu = [] } = useGetMenuQuery();

  const adId = 'ActiveDirectory';

  return (
    <nav className={styles['menu']}>
      <SimpleTreeView defaultSelectedItems={adId} selectedItems={adId}>
        {menu.map((item, index) => {
          const icon = menuIcons[item.css_class];

          if (item.children.length > 0) {
            return (
              <TreeItem
                key={item.url}
                itemId={`${index}-children-${item.title}`}
                label={
                  <>
                    <img src={icon} alt="menu icon" />
                    {item.title}
                  </>
                }
                slots={{
                  expandIcon: ExpandIcon,
                  collapseIcon: CollapseIcon,
                }}
                classes={{
                  iconContainer: styles['MuiTreeItem-iconContainer'],
                  label: styles['MuiTreeItem-label'],
                  content: styles['MuiTreeItem-content'],
                  groupTransition: styles['MuiCollapse-root'],
                  focused: styles['Mui-focused'],
                }}
              >
                {item.children.map((child, index) => (
                  <TreeItem
                    key={child.url}
                    itemId={`${index}-child-${child.title}`}
                    label={
                      <Link url={BASE_URL + child.url} title={child.title} />
                    }
                    classes={{
                      label: styles['MuiTreeItem-label'],
                      content: styles['MuiTreeItem-content-child'],
                    }}
                  />
                ))}
              </TreeItem>
            );
          }

          let itemId =
            item.title === 'ActiveDirectory' ? adId : `${index}-${item.title}`;

          return (
            <TreeItem
              key={item.url}
              itemId={itemId}
              classes={{
                iconContainer: styles['MuiTreeItem-iconContainer'],
                label: styles['MuiTreeItem-label'],
                content: styles['MuiTreeItem-content'],
                selected: styles['Mui-selected'],
              }}
              label={
                <Link
                  url={BASE_URL + item.url}
                  title={item.title}
                  icon={icon}
                />
              }
            />
          );
        })}
      </SimpleTreeView>

      <div className={styles['mobile-logout']}>
        <span className={headerStyles['header-controls-account']}>
          {username}
        </span>
        {is_authenticated ? (
          <a
            href={`${BASE_URL}/auth/logout/`}
            className={headerStyles['header-controls-logout']}
          >
            <span className={appStyles['offscreen']}>Logout</span>
          </a>
        ) : null}
      </div>
    </nav>
  );
};

export default Menu;
